<template>
    <qr-code :text="qrCodeSrc" class="qr_pic" error-level="L"></qr-code>
</template>

<script>
import QRCode from 'vue-qrcode-component'

export default {
  name: 'Demo',
  components: { QRCode },
  data () {
    return {
      qrCodeSrc: '处理完上面的问题后测试安卓机正常了，但是iOS机型微信中在/b页面复制地址中仍然/a页面，查看资料网上很多人都说可以通过链接的方式处理。'
    }
  }
}
</script>

<style scoped>

</style>
